import React from 'react'
import { BsX } from 'react-icons/bs';
import { SiMongodb, SiExpress, SiReact, SiNodedotjs } from 'react-icons/si';
import styles from '../componentsStyles/NewCardsComponent.module.css';

const NewCardsComponent2 = () => {
  return (
    <div className={styles.newCardsComponent}>

       <div className={styles.cardsArea}>
            <input type="radio" name='card2' id='cardcb5' className={styles.Cardcb5}/>
            <input type="radio" name ='card2' id="cardcb6" className={styles.cbCard6}/>
            <label className={`${styles.cardWrapper} ${styles.cardWrapper6}`} htmlFor='cardcb6'>
                <div  className={`${styles.card} ${styles.card1}`} >
                    
                    <div className={styles.cardFront}>

                        <div className={styles.top} >
                            <SiMongodb className={styles.smallIcon}/>
                        </div>

                        <SiMongodb className ={styles.icon}/>
                        <h3>Mongo db</h3>

                        <div className={styles.botton}>
                            <SiMongodb className={styles.smallIcon}/>
                        </div>

                    </div>

                    <div className={styles.cardback}>
                        <div className={styles.top} >
                            <SiMongodb className={styles.smallIcon}/>
                            <label htmlFor="cardcb5"><BsX className={styles.closeIcon}/></label>
                        </div>
                        
                        <div className={styles.cardText}>
                          <p>
                          A simple, high-performance no-SQL database.
                          </p>
                          <p>
                          It offers greater flexibility in data planning and is easy to integrate into applications.
                          </p>  
                        </div>
                        
                        <div className={styles.botton}>
                            <SiMongodb className={styles.smallIcon}/>
                        </div>
                    </div>

                </div>
            </label>


           
            <input type="radio" name ='card2' id="cardcb7" className={styles.cbCard7}/>
            <label htmlFor='cardcb7' className={`${styles.cardWrapper} ${styles.cardWrapper7}`}>
                <div className={`${styles.card} ${styles.card2}`}>
                    
                    <div className={styles.cardFront}>

                        <div className={styles.top}>
                            <SiExpress className={styles.smallIcon}/>
                        </div>
                        <SiExpress className ={styles.icon}/>
                        <h3>Express.js</h3>
                        <div className={styles.botton}>
                            <SiExpress className={styles.smallIcon}/>
                        </div>

                    </div>

                    <div className={styles.cardback}>

                        <div className={styles.top} >
                            <SiExpress className={styles.smallIcon}/>
                            <label htmlFor="cardcb5"><BsX className={styles.closeIcon}/></label>
                        </div>
                        
                        <div className={styles.cardText}>
                          <p>
                          A package build for creating backends that rely on JavaScript code.
                          </p>
                          <p>
                          Lightweight, with a vast set of tools to use.
                          </p>  
                        </div>
                        
                        <div className={styles.botton}>
                            <SiExpress className={styles.smallIcon}/>
                        </div>

                    </div>

                </div>

            </label>
           
            <input type="radio" name ='card2' id="cardcb8" className={styles.cbCard8}/>
            <label htmlFor='cardcb8' className={`${styles.cardWrapper} ${styles.cardWrapper8}`}>
                <div className={`${styles.card} ${styles.card3}`}>

                    <div className={styles.cardFront}>
                        <div className={styles.top}>
                            <SiReact className={styles.smallIcon}/>
                        </div>
                        <SiReact className ={styles.icon}/>
                        <h3>React</h3>
                        <div className={styles.botton}>
                            <SiReact className={styles.smallIcon}/>
                        </div>
                    </div>

                    <div className={styles.cardback}>

                        <div className={styles.top} >
                            <SiReact className={styles.smallIcon}/>
                            <label htmlFor="cardcb5"><BsX className={styles.closeIcon}/></label>
                        </div>
                        
                        <div className={styles.cardText}>
                          <p>
                           The most popular JavaScript front end framework.
                          </p>
                          <p>
                          Highly integrable, apps and websites are easy to scale with this framework
                          </p>  
                        </div>
                        
                        <div className={styles.botton}>
                            <SiReact className={styles.smallIcon}/>
                        </div>

                    </div>

                </div>
            </label>
           
            <input type="radio" name ='card2' id="cardcb9" className={styles.cbCard9}/>
            <label htmlFor='cardcb9' className={`${styles.cardWrapper} ${styles.cardWrapper9}`}>
                <div className={`${styles.card} ${styles.card4}`}>
                    
                    <div className={styles.cardFront}>
                        <div className={styles.top}>
                            <SiNodedotjs className={styles.smallIcon}/>
                        </div>
                        <SiNodedotjs className ={styles.icon}/>
                        <h3>Node.js</h3>
                        <div className={styles.botton}>
                            <SiNodedotjs className={styles.smallIcon}/>
                        </div>
                    </div>

                    <div className={styles.cardback}>

                        <div className={styles.top} >
                            <SiNodedotjs className={styles.smallIcon}/>
                            <label htmlFor="cardcb5"><BsX className={styles.closeIcon}/></label>
                        </div>
                        
                        <div className={styles.cardText}>
                          <p>
                           Environment that hosts a large number of JavaScript packages.
                          </p>
                          <p>
                          Keeps everything in order, ensuring that all packages used in live applications will work as needed.
                          </p>  
                        </div>
                        
                        <div className={styles.botton}>
                            <SiNodedotjs className={styles.smallIcon}/>
                        </div>

                    </div>


                </div>
            </label>    
       </div>
    
    
    </div>
  )
}

export default NewCardsComponent2